import { ECode } from '../repositories/price-estimator/entities/thin_client_info/MyHomeStatusInfoSchema';
import { EStatus } from '../repositories/price-estimator/entities/user_status/UpdateMyHomeStatusRequestSchema';

export const mapECodeToEStatus = {
  [ECode.Investment]: EStatus.Investment,
  [ECode.NeedSale]: EStatus.NeedSale,
  [ECode.NotSelected]: EStatus.NotSelected,
  [ECode.Other]: EStatus.Other,
  [ECode.RentOrNeedRent]: EStatus.RentOrNeedRent,
  [ECode.SomebodyWantKnowPrice]: EStatus.SomebodyWantKnowPrice,
  [ECode.ThinkRentOrSale]: EStatus.ThinkRentOrSale,
  [ECode.WantKnowSalePrice]: EStatus.WantKnowSalePrice,
  [ECode.WantToBuy]: EStatus.WantToBuy,
};
